import React from "react";

interface CurrencyInputProps {
  label: string;
  value: string;
  onChange: (val: string) => void;
  placeholder?: string;
  error?: string;
}

const formatWithCommas = (value: string) => {
  const numeric = value.replace(/,/g, "").replace(/[^\d]/g, "");
  return numeric ? parseInt(numeric, 10).toLocaleString() : "";
};

const CurrencyInput: React.FC<CurrencyInputProps> = ({
  label,
  value,
  onChange,
  placeholder = "Enter amount",
  error,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatWithCommas(e.target.value);
    onChange(formatted);
  };

  return (
    <div className="flex flex-col gap-1 mb-4 w-full">
      <label className="text-sm font-medium">{label}</label>
      <input
        type="text"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        inputMode="numeric"
        className={`w-full border rounded-md p-2 focus:outline-none focus:ring-1 focus:ring-primary min-h-[60px] ${
          error
            ? "border-red-500 focus:border-red-500 focus:ring-red-200"
            : "border-gray-300 focus:border-blue-500 focus:ring-blue-200"
        }`}
      />
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  );
};

export default CurrencyInput;
